import { render } from "./4.vue?vue&type=template&id=3ac3fec1"
import script from "./4.vue?vue&type=script&lang=js"
export * from "./4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__